<div class="w-100 float-left">
    <div class="w-100 float-left v-align relative b-b">
        <h5 class="medium float-left">{{'createTenant' | translate}}</h5>
        <div style="flex-grow: 1;"></div>
        <button class="btn float-left mb-2" (click)="goBack()"> {{'back' | translate}}</button>

    </div>
    <form novalidate #tenantForm="ngForm">
        <div class="w-100 float-left light-bg p-3 mb-4">
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="m-0">{{'tenantDetails' | translate}}</h5>
                <div class="ml-alert">
                </div>
                <div style="flex-grow: 1;"></div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
                <div class="w-100 float-left form-group">
                    <label>{{'tenantName' | translate}}
                        <span class="text-danger medium">*</span>:</label>
                    <div class="align-v-center w-100 float-left">
                        <div class="col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0">
                            <input type="text" class="form-control" min="0" name="orgName"
                                   [(ngModel)]="createNewTenantData.orgName"
                                   required autocomplete="off">
                        </div>

                    </div>
                </div>
                <div class="w-100 float-left form-group">
                    <label for="lanId">{{'language' | translate}}
                        <span class="text-danger medium">*</span>:</label>
                    <div class="align-v-center w-100 float-left">
                        <div class="col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0">
                            <angular2-multiselect [data]="itemLangList" [(ngModel)]="selectedLangItems"
                                                  [ngModelOptions]="{standalone: true}" [settings]="langSettings">
                                <c-item>
                                    <ng-template let-item="item">
                                        <label style="color: #333;width: 150px;">{{item.name}}</label>
                                    </ng-template>
                                </c-item>
                            </angular2-multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
                <div class="w-100 float-left form-group">
                    <label>{{'tenantShortName' | translate}}
                        <span class="text-danger medium">*</span>:</label>
                    <div class="align-v-center w-100 float-left">
                        <div class="col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0">
                            <input type="text" class="form-control" name="shortName"
                                   [(ngModel)]="createNewTenantData.shortName"
                                   required autocomplete="off">
                        </div>
                    </div>
                </div>
                <div class="w-100 float-left form-group">
                    <label for="timeZone">{{'timeZone' | translate}}
                        <span class="text-danger medium">*</span>:</label>
                    <select class="form-control col-lg-9 col-md-9" id="timeZone" name="timeZone"
                            [(ngModel)]="createNewTenantData.timeZone">
                        <option value='' selected disabled>--{{'select' | translate}}--</option>
                        <!-- <option *ngFor="let cast of cascadeTypeValueMap" [value]="cast.value">{{cast.key}}</option> -->
                        <option value="GMT+01:00">{{'UTCCETGermany' | translate}}</option>
                        <option value="GMT+08:00">{{'UTCMSTMalaysia' | translate}}</option>
                        <option value="GMT+05:30">{{'UTCISTIndia' | translate}}</option>
                        <option value="GMT+07:00">{{'UTCIWSTIndonesia' | translate}}</option>
                        <option value="GMT+08:00">{{'UTCICSTIndonesia' | translate}}</option>
                        <option value="GMT+09:00">{{'UTCIESTIndonesia' | translate}}</option>
                        <option value="GMT+08:00">{{'UTCSSTSingapore' | translate}}</option>
                        <option value="GMT+05:30">{{'UTCSLSTSriLanka' | translate}}</option>
                        <option value="GMT+04:00">{{'UTCGSTUAE' | translate}}</option>
                        <option value="GMT-05:00">{{'UTCESTUSA' | translate}}</option>
                        <option value="GMT-06:00">{{'UTCCSTUSA' | translate}}</option>
                        <option value="GMT-07:00">{{'UTCMSTUSA' | translate}}</option>
                        <option value="GMT-08:00">{{'UTCPSTUSA' | translate}}</option>
                        <option value="GMT-09:00">{{'UTCASTUSA' | translate}}</option>
                        <option value="GMT-10:00">{{'UTCHSTUSA' | translate}}</option>
                        <!-- <option value="GMT+02:00">{{'UTCSASTSouthAfrica' | translate}}</option> -->
                    </select>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
                <div class="w-100 float-left form-group">
                    <label for="lanId">{{'app' | translate}}
                        <span class="text-danger medium">*</span>:</label>
                    <select class="form-control col-lg-9 col-md-9" id="lanId" name="lanId" #lange="ngModel"
                            [(ngModel)]="selectedApp"
                            required>
                        <option value='' selected disabled>--{{'select' | translate}}--</option>
                        <option *ngFor="let app of apps" [value]="app.id">{{app.mobileAppName}}</option>
                    </select>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
                <label class="w-100">{{'tenantBaseUrl' | translate}}
                    <span class="text-danger medium">*</span>:</label>
                <div class="w-75 float-left">
                    <div class="input-group mb-3">
                        <input type="text" (keypress)="omit_special_char($event)" class="form-control" name="baseUrl"
                               [(ngModel)]="beforeAppending" aria-label="Recipient's username"
                               aria-describedby="basic-addon2"
                               required pattern="\b((?=[a-z0-9-]{1,63}\.)[a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,63}\b"
                               required
                               autocomplete="off">
                        <div class="input-group-append">
                            <span class="input-group-text" id="basic-addon2">{{urlExt}}</span>
                        </div>
                    </div>
                </div>
            </div>


        </div>


        <div class="w-100 float-left light-bg p-3 mb-4">
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="m-0">{{'primeContactDetails' | translate}}</h5>
                <div class="ml-alert">
                </div>
                <div style="flex-grow: 1;"></div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
                <div class="w-100 float-left form-group">
                    <label>
                        {{'displayName' | translate}}
                        <span class="text-danger medium">*</span>:</label>
                    <div class="align-v-center w-100 float-left">
                        <div class="col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0">
                            <input type="text" class="form-control" min="0" name="displayName"
                                   [(ngModel)]="createNewTenantData.displayName"
                                   required autocomplete="off">
                        </div>

                    </div>
                </div>
                <div class="w-100 float-left form-group">
                    <label for="email">{{'email' | translate}}
                        <span class="text-danger medium">*</span>:</label>
                    <div class="align-v-center w-100 float-left">
                        <div class="col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0">
                            <input type="email" class="form-control" [(ngModel)]="createNewTenantData.email"
                                   placeholder="Eg: jack@oracle.com"
                                   pattern="[a-z0-9A-Z._%+-]+@[a-z0-9A-Z.-]+\.[a-zA-Z]{2,3}$"
                                   name="email" id="email" #email="ngModel" maxlength="80"
                                   (ngModelChange)="copyToUsername($event)"
                                   required autocomplete="off">
                            <div *ngIf="email.invalid && (email.dirty || email.touched)" style="padding:5px"
                                 class="info-text  alert-danger">
                                <div *ngIf="email.errors.required">
                                    {{'empEmailRequired' | translate}}
                                </div>
                                <div *ngIf="email.errors.pattern">
                                    {{'invalidEmail' | translate}}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
                <div class="w-100 float-left form-group">
                    <label>{{'userName' | translate}}
                        <span class="text-danger medium">*</span>:</label>
                    <div class="align-v-center w-100 float-left">
                        <div class="col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0">
                            <input type="text" class="form-control" name="username"
                                   [(ngModel)]="createNewTenantData.userName"
                                   required autocomplete="off">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-100 float-left light-bg p-3 mb-4">
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="m-0">{{'selectModuleDetails' | translate}}</h5>
                <div class="ml-alert">
                </div>
                <div style="flex-grow: 1;"></div>
            </div>
            <div class="w-100 float-left text-13x">
                <div class="w-100 float-left" *ngFor="let module of modules;index as i">
                    <div class="float-left text-center mb-1 mt-1">
                        <div class="checkbox checkbox-primary">
                            <input [id]="i" name="{{i}}" type="checkbox" [(ngModel)]="module.assigned">
                            <label [for]="i" class="mb-0 float-left mr-2"></label>
                            <p class="float-left text-13x mb-0"> {{module.operation+'_MODULE' | translate}} </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <button class="btn btn-primary float-right mb-4 ml-4" type="submit" (click)="createNewTenant()"
                [disabled]="buttonDisabled">
            {{'createTenant' | translate}}
            <!-- [disabled]="tenantForm.invalid" -->
            <!-- <i *ngIf="showButtonLoading" class="fa fa-spinner fa-spin text-white m-l-smd"></i> -->
        </button>
    </form>
</div>


// WEBPACK FOOTER //
// ./src/app/superAdmin/createTenant.html